import React from 'react';
import { NavLink } from 'react-router-dom';

export default class SettingsMenu extends React.Component {
    render() {
        return <div>
            <h2 className="page-header settings-header">Settings</h2>
            <ul className="settings-options">
                <li><NavLink activeclassname="active" to="/settings/user">User Settings</NavLink></li>
                <li><NavLink activeclassname="active" to="/settings/system">System Settings</NavLink></li>
                <li><NavLink activeclassname="active" to="/settings/printing">Print Checks</NavLink></li>
            </ul>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/SettingsMenu.jsx